// slice habdles local state for add product multistep form
// necessary to centralize state management for add product form over the steps

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  favorites: JSON.parse(localStorage.getItem("dari-fav")) || [],
};

export const favoriteSlice = createSlice({
  name: "favorites",
  initialState,
  reducers: {
    addFavorite: (state, action) => {
      console.log(action.payload);
      const newFavs = state.favorites.filter(
        (fav) => fav._id !== action.payload._id
      );
      newFavs.push(action.payload);
      state.favorites = newFavs;

      localStorage.setItem("dari-fav", JSON.stringify(newFavs));
    },
    deleteFavoriteItem: (state, action) => {
      const newFavs = state.favorites.filter(
        (fav) => fav._id !== action.payload.id
      );
      state.favorites = newFavs;
      localStorage.setItem("dari-fav", JSON.stringify(newFavs));
    },
  },
});

export const { addFavorite, deleteFavoriteItem } = favoriteSlice.actions;

export default favoriteSlice.reducer;
